import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueI18n from 'vue-i18n'
import VueDND from 'awe-dnd'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import store from "./store";
import {getPackage,deletePackage,putPackage,postPackage} from "./network";
import {requestUrl} from "./api/requestUrl";
import {redirectUri} from "./const/redirectUri";

import directives from './directives'
// 全局注册指令

import VueClipboard from 'vue-clipboard2'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
// ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
/*import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
var height=screen.height
var width=screen.width
Vue.use((VueDirectiveImagePreviewer),{
    zIndex: 9999,  //层级显示
    previewSize: 3,
    clickMethod:'click',
    maxWidth:width,
    maxHeight:height,
    animate: {
        duration: 600,
        delay: 500
    },
})*/
// 图表v-charts
// import VCharts from 'v-charts';
import CKEditor from '@ckeditor/ckeditor5-vue';
import echarts from 'echarts'

Vue.use(CKEditor);
Vue.prototype.$echarts = echarts
 
// Vue.use(VCharts);
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.prototype.$http = axios;
Vue.use(directives)
Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueDND)
Vue.use(VueQuillEditor)
Vue.use(VueI18n);
Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.getPackage=getPackage;
Vue.prototype.deletePackage=deletePackage;
Vue.prototype.putPackage=putPackage;
Vue.prototype.postPackage=postPackage;
Vue.prototype.requestUrl=requestUrl
Vue.prototype.getVal=function (key){
    var url = location.href.split("?");
    if(url[1]==null)return false;
    var field = url[1].split("&");
    for(let i=0;i<field.length;i++){
        var val = field[i].split("=");
        if(val[0]==key){
            return val[1];
        }
    }
    return false;
}
Date.prototype.Format = function (fmt) { //author: meizz
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
import {i18n_messages} from './i18n/i18n'
const i18n = new VueI18n({
    locale: 'zh-CN',
    messages: i18n_messages
});
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next()
})
new Vue({
    i18n,
    router,
    store,
  render: h => h(App)
}).$mount('#app');


axios.interceptors.request.use(
    config => {
        let token = localStorage.getItem('token');
        config.headers.common.Authorization = 'Bearer ' + token;
        config.headers.common.mainId = localStorage.getItem('_mainId');
        config.headers.common.uid = localStorage.getItem('_uid');
        config.headers.common.source ='SCRM'
        if (localStorage.getItem('_mainId')==null ||localStorage.getItem('_mainId')==''){
            location.hash = "/auth";
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//axios response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.log("=========current error status:",error.response.status);
        if(error.response.status==510){
            console.log("============== exe 510 action");
            location.href=redirectUri[process.env.VUE_APP_ASK_ENV].expired;
        } else if (error.response.status === 403) {
            location.hash = "/auth";
        } 
        return Promise.reject(error);
        // if (error.response.status === 403) {
        //     location.hash = "/auth";
        // } else {
        //     return Promise.reject(error)
        // }
    }
);

